import  {   AbstractControl
        ,   ValidationErrors
        ,   Validator 
        ,   ValidatorFn             } from "@angular/forms";
import  {   CustomValidator         } from "../beans/errors/custom-validator.bean";

export function genericValidator (  validators: CustomValidator[]  ): ValidatorFn {

    return ( ctrl: AbstractControl ): ValidationErrors | null => {        
        if ( !validators || validators.length == 0 ) 
            return null 

        const output: ValidationErrors = {}
        validators.forEach( ( val ) => {
            let formValue = null

            if( val.ctrlName )
                formValue = ctrl?.get( val.ctrlName )?.value 
            else 
                formValue = ctrl?.value 
                
            let valid: boolean = true                
            if ( val.isValid ){
                try{
                    valid = (val.isValid as ValidatorFn)( ctrl ) == null             
                }catch(error){                        
                    if ( val.isValid instanceof Function ) 
                        valid = val.isValid( formValue )
                }
            }            
            
            if ( !valid )
                output[val.validation.validatorName] = true                     
            
        } ) 
        
        return output == {} ? null : output ;
        
    }
    
}
          